export default __webpack_public_path__ + "static/media/BulkWorkerUploadTemplate.7b8fa518.csv";